import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  TemplateRef,
  Type,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';
import { IconType, TRole } from '@aksia/infrastructure';
import { IconComponent } from '../../presentation/icon/icon.component';
import { HasRoleDirective } from '../../../directives/ui/ui-has-role.directive';

export type TNavItem = {
  title: string;
  icon?: {
    iconDefinition: IconType;
    iconSize?: string;
    iconColor?: string;
    iconClass?: string;
  };
  routerLink: string;
  routerLinkActive?: string;
  role?: TRole;
};

@Component({
  selector: 'page-nav',
  imports: [CommonModule, RouterModule, IconComponent, HasRoleDirective],
  templateUrl: './page-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNavComponent extends UiControlDirective {
  //#region Host Bindings

  @HostBinding('attr.uipagenav') uipagenav = '';

  //#endregion

  //#region Inputs

  navItemsTemplateRef = input<TemplateRef<any> | null>(null);
  navItemsComponentRef = input<Type<any> | null>(null);
  navItems = input<Array<TNavItem> | undefined>(undefined);

  //#endregion
}
